export default "__VITE_ASSET__CltfbJkO__"